import { hookupCanvas, GLCanvas } from "dok-gl-canvas";
const exports = {
    hookupCanvas,
    GLCanvas,
};
export default exports;
globalThis.exports = exports;
